import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100vh; /* Full viewport height */
  overflow: hidden; /* Prevent double scroll */
  background-color: white;

  @media (width <= 1024px) {
    padding: 10px;
    overflow: visible;
    height: 100%;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1; /* Take remaining space below Tabs */
  overflow-y: visible; /* Let individual pages handle their own scrolling */
`;
